import { Stack } from 'ui/stack';

import { Typography } from 'ui/typography';
import TableComponent from 'components/partials/table-component/table-component';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';
import { Loader } from 'ui/loader';

import { useInsights } from 'containers/admin/clients/client/tabs-components/insights-tab/hooks/use-insights';
import { getInsightsTableSettings } from 'containers/admin/clients/client/tabs-components/insights-tab/insights-tab-table-settings';

interface InsightsTabProps {
  clientId: string | number | undefined;
}

const InsightsTab = ({ clientId }: InsightsTabProps): React.JSX.Element => {
  const {
    insights,
    initialLoading,
    isLoading,
    sortingParams,
    setSortingParams,
  } = useInsights({ clientId });

  const columns = getInsightsTableSettings({
    clientId,
  });

  const renderContent = (): React.JSX.Element | null => {
    if ((!!insights.length && !isLoading) || (isLoading && !initialLoading)) {
      return (
        <TableComponent
          columns={columns}
          data={insights}
          isLoading={isLoading}
          sortingParams={sortingParams}
          setSortingParams={setSortingParams}
          pagination={false}
          customHeight="max-h-[50vh]"
        />
      );
    }

    if (!isLoading && insights.length === 0) {
      return (
        <EmptySpaceContent
          customClass="flex-1"
          text="There are no insights to show yet."
        />
      );
    }

    return null;
  };

  return (
    <Stack sx={{ position: 'relative', flex: '1 1 0%' }}>
      <Loader loading={initialLoading} backdrop="white" fullScreen={false} />

      <Stack
        direction="row"
        sx={{ justifyContent: 'space-between', alignItems: 'center', my: 2.5 }}
      >
        <Typography data-testid="client-insights-tab-heading" variant="h2">
          Insights
        </Typography>
      </Stack>

      <Stack sx={{ position: 'relative', flex: '1 1 0%' }}>
        {renderContent()}
      </Stack>
    </Stack>
  );
};

export default InsightsTab;
